window.utils = {
    getMobileDeviceName: function () {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }

        if (/android/i.test(userAgent)) {
            return 'Android';
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && ! window.MSStream) {
            return 'iOS';
        }

        return 'n/a';
    },

    isMobileDevice: function () {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return true;
        }

        if (/android/i.test(userAgent)) {
            return true;
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPhone/.test(userAgent) && ! window.MSStream) {
            return true;
        }

        return false;
    },

    isDeviceSupportingBankId: function () {
        return window.utils.isMobileDevice();
    },

    scrollIt: (element, behavior = 'smooth', callback, offset) => {
        if (typeof element === 'string') {
            element = document.querySelector(element);
        }

        if (! element) {
            return;
        }

        offset = offset || 0;

        window.scroll({ top: element.offsetTop + offset,  left: 0,  behavior: behavior });

        // We need to wait for the scroll to be done before we can
        // execute the timeout (eg. "focus" will stop the scrolling)
        const timeout = behavior === 'smooth' ? 400 : 0;

        if (callback) {
            setTimeout(() => callback(), timeout);
        }
    },

    scrollItAndFocus: function (elementSelector) {
        const element = document.querySelector(elementSelector);
        if (element) {
            window.utils.scrollIt(element, 'smooth', () => element.focus());
        }
    },

    /**
     * Check if window width is at a certain breakpoint or wider
     *
     * Usage: if (window.utils.breakpoint('md')) {...}
     *
     * @param {String} size
     * @returns {boolean}
     */
    breakpoint: function (size) {
        const breakpoints = {
            md: 768,
            lg: 1024,
            xl: 1280,
            xxl: 1440,
        };

        if (breakpoints[size]) {
            return window.innerWidth >= breakpoints[size];
        }

        return false;
    },

    isLastOfDayInMonth: function (date, day) {
        var d = new Date(date);
        return d.getDay() === day && (d.getDate() + 7) > 31;
    },


};

window.utils.isLastTuesday = function (date) {
    return window.utils.isLastOfDayInMonth(date, 2);
};
